import _ from 'lodash';
import PropTypes from 'prop-types';

export const defaultProfileCompleteness = {
  standard: {
    organization: false,
    position: false,
    blurb: false,
    areasOfExpertise: false,
    headlineGrab: false,
    country: false,
    joinedCurrentRoleAt: false,
    profileCareers: false,
    joinedIndustryAt: false,
    investmentPhilosophy: false,
  },
  premium: {
    featuredWires: false,
    profileLinks: false,
  },
  activeFeatures: [],
};

// These two mimics Rails' `present?` method.
const stringCoercer = s => !_.isEmpty(_.trim(s));
const arrayCoercer = a => !_.isEmpty(a);

const coercer = {
  organization: stringCoercer,
  position: stringCoercer,
  blurb: stringCoercer,
  areasOfExpertise: arrayCoercer,
  headlineGrab: stringCoercer,
  country: stringCoercer,
  joinedCurrentRoleAt: stringCoercer,
  profileCareers: d => _.every(d, stringCoercer),
  joinedIndustryAt: stringCoercer,
  investmentPhilosophy: d => _.some(d, stringCoercer),
  featuredWires: arrayCoercer,
  profileLinks: d => _.some(d, stringCoercer),
};

export const profileCompletenessType = PropTypes.shape({
  standard: PropTypes.shape(_.mapValues(defaultProfileCompleteness.standard, () => PropTypes.bool)),
  premium: PropTypes.shape(_.mapValues(defaultProfileCompleteness.premium, () => PropTypes.bool)),
  activeFeatures: PropTypes.arrayOf(PropTypes.string),
});

export function calculateScore(completeness) {
  const isStd = _.includes(completeness.activeFeatures, 'standard_profile_page');
  const isPrm = _.includes(completeness.activeFeatures, 'premium_featured_wires')
    && _.includes(completeness.activeFeatures, 'premium_social_links');

  if (!isStd) {
    return 1;
  }

  const collection = { ...completeness.standard };
  isPrm && _.merge(collection, completeness.premium);
  const d = _.reduce(collection, (result, v) => ({
    total: result.total + 1,
    truth: result.truth + (v ? 1 : 0),
  }), { total: 0, truth: 0 });

  return d.truth / d.total;
}

export function updateCompleteness(completeness, update) {
  const isStd = _.includes(completeness.activeFeatures, 'standard_profile_page');
  const isPrm = _.includes(completeness.activeFeatures, 'premium_featured_wires');

  if (!isStd) {
    return { ...completeness };
  }

  const result = { ...completeness };
  const key = _.first(_.keys(update));
  if (_.includes(_.keys(defaultProfileCompleteness.standard), key)) {
    result.standard[key] = coercer[key](update[key]);
  } else if (isPrm && _.includes(_.keys(defaultProfileCompleteness.premium), key)) {
    result.premium[key] = coercer[key](update[key]);
  }
  return result;
}
